import { useMediaQuery, Theme } from '@mui/material';
import FeatureFlags from 'constants/featureFlags';
import { useFeatureFlag } from './useFeatureFlag';

export enum DeviceType {
  DESKTOP = 'desktop',
  ANDROID = 'android',
  IOS = 'ios',
}

const devicesMap: Record<DeviceType, string[]> = {
  [DeviceType.ANDROID]: ['android'],
  [DeviceType.IOS]: ['iphone', 'ipad', 'ipod'],
  [DeviceType.DESKTOP]: [],
};

const useMobile = () => {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const isMobileFeatureEnabled = useFeatureFlag(FeatureFlags.MOBILE);
  const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent.toLowerCase() : '';
  const device =
    Object.keys(devicesMap).find((deviceType) =>
      devicesMap[deviceType as DeviceType].some((keyword) => userAgent.includes(keyword))
    ) || DeviceType.DESKTOP;

  return {
    device,
    isMobileView,
    isMobileFeatureEnabled,
    isAndroid: device === DeviceType.ANDROID,
    isIOS: device === DeviceType.IOS,
    isDesktop: device === DeviceType.DESKTOP,
    showMobile: isMobileFeatureEnabled && isMobileView,
  };
};

export default useMobile;
